import { API } from "../../../api/constants"
import { authenticatedAxiosInstance } from "../../../auth/AuthenticatedAxios"
import { KeycollectionType } from "../../Objekte/types/types"

export const getKeysPaginate = (params?: {
    page?: number | string
    limit?: number | string
    search?: string
    invertSort?: boolean | string
}) => {
    const queryParts: string[] = []
    if (params?.page !== undefined && params?.page !== null && params?.page !== "") queryParts.push(`page=${params.page}`)
    if (params?.limit !== undefined && params?.limit !== null && params?.limit !== "") queryParts.push(`limit=${params.limit}`)
    if (params?.search) queryParts.push(`search=${encodeURIComponent(params.search)}`)
    if (params?.invertSort !== undefined && params?.invertSort !== null && params?.invertSort !== "") queryParts.push(`invertSort=${params.invertSort}`)
    const query = queryParts.length ? `?${queryParts.join("&")}` : ""
    return authenticatedAxiosInstance.get(API + `/keys/paginate${query}`).then((res) => res.data)
}

export const getSingleKeyData = (id: string) =>
    authenticatedAxiosInstance.get(API + `/keys/${id}`).then((res) => res.data)

export const createKey = (body: any) =>
    authenticatedAxiosInstance.post(API + "/keys", body).then((res) => res.data)

export const updateKey = (data: KeycollectionType, id: string) =>
    authenticatedAxiosInstance
        .put(API + `/keys/${id}`, data)
        .then((res) => res.data)

export const deleteKey = (id: string) =>
    authenticatedAxiosInstance.delete(API + `/keys/${id}`).then((res) => res.data)



